/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum DiscrepanciesReason {
  OverDelivered = 'OVER_DELIVERED',
  UnderDelivered = 'UNDER_DELIVERED',
  NotAnnounced = 'NOT_ANNOUNCED',
  RefusalOfAcceptance = 'REFUSAL_OF_ACCEPTANCE'
}
